<template>
  <div class="grid-y flex-grow divide-y" v-if="category">
    <div class="flex flex-col">
      <CategoryCard
      :category="category"
      :hasServicesCount="false"
      :isEditLayout="true"
      @activate="onCategoryActivate"
      @deactivate="onCategoryDeactivate"
      @save-category="onSaveCategoryClick"
      />
    </div>
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabs"/>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto cell-block-y flex flex-grow">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <Modal
      id="add"
      :fullScreen="true"
      :hide-footer="true"
      :hideHeaderClose="false"
      >
      <template v-slot:modal-header-close>
        <img src="@/assets/icons/modal-header-close.svg" alt="modal-header-close" />
      </template>
      <template v-slot:modal-title>
        <div class="flex items-center w-full justify-between">
          <Input
            label="Добавьте название услуги:"
            placeholder="Введите название"
            classes="bg-hint w-110"
            :invalid="$v.service.name.$error"
            v-model="service.name"/>
          <button class="btn btn-sm btn-primary font-normal"
          @click="onServiceCreateClick(category.id)">Опубликовать услугу</button>
        </div>
      </template>
      <div slot class="flex flex-col pt-8">
        <div class="flex flex-col space-y-8 pl-48">
          <Input
            label="Категория услуг:"
            placeholder=""
             classes="bg-hint border-none w-150"
            :disabled="true"
            :icon="category.iconAttach"
            v-model="category.name"/>
          <V2AttachmentUpload
            mode="card"
            v-model="service.v2ImageAttach"
            title="Изображение услуги для новой формы"
            hint="Необязательно. Большая картинка слева в карточке услуги. Если её нет, используется иконка категории. Рекомендуемый размер — 1024×1024."
          />
          <Input
            label="Описание услуги:"
            :textarea="true"
            placeholder="Введите описание услуги"
            classes="w-150"
            :invalid="$v.service.description.$error"
            v-model="service.description"/>
          <Input
            label="Стоимость услуги:"
            placeholder="Введите стоимость"
            classes="bg-hint w-110"
            :inputmask="{
              alias: 'decimal',
              rightAlign: false,
              allowMinus: false,
              placeholder: '',
            }"
            :invalid="$v.service.price.$error"
            v-model="service.price"/>
          <div class="flex flex-col">
            <span class="flex text-sm text-muted mb-4">Тип товара:</span>
            <RadioButtonSet :options="countableOptions" v-model="service.countable"
            :invalid="$v.service.countable.$error"
            size="big" />
          </div>
          <div class="flex flex-col">
            <span class="flex text-sm text-muted mb-4">Обязательное поле для заказа:</span>
            <RadioButtonSet :options="requiredOptions"
            :invalid="$v.service.required.$error"
            v-model="service.required" size="big" />
          </div>
        </div>
        <div class="flex flex-col py-8 border-t border-solid border-light pl-48 mt-8">
          <Input
            label="Дополнительные опции:"
            placeholder="Укажите дополнительные опции"
            classes="bg-hint border-none w-150"
            v-model="optionName"
            @enter="onEnter"
            :options="additionalOptions"
            @option-delete="onOptionDelete"
            />
        </div>
        <div class="flex flex-col py-8 border-t border-solid border-light pl-48">
          <span class="flex text-sm text-muted mb-4">Показывать на экране Поиска:</span>
          <RadioButtonSet :options="showAtMobileSearchScreenOptions" size="big"
          :invalid="$v.service.showAtMobileSearchScreen.$error"
          v-model="service.showAtMobileSearchScreen" />
        </div>
        <div class="flex flex-col py-8 border-t border-solid border-light pl-48">
          <div class="max-w-300px pb-16">
            <span class="flex text-sm text-muted mb-4">Для каких объектов доступна услуга:</span>
            <Select
            :options="applicableToOptions"
            :class="['bg-hint', {
              'border border-solid border-hint':
                !$v.service.applicableTo.$dirty || !$v.service.applicableTo.$invalid,
              'border border-solid border-danger':
                $v.service.applicableTo.$dirty && $v.service.applicableTo.$invalid,
            }]"
            :label="'name'"
            :value="service.applicableTo"
            @input="($event) => service.applicableTo = $event"
            placeholder="Выберите доступность услуги"/>
          </div>
        </div>
      </div>
    </Modal>
    <Modal
      id="edit"
      :fullScreen="true"
      :hide-footer="true"
      :hideHeaderClose="false"
      @hidden="onEditModalHidden"
      >
      <template v-slot:modal-header-close>
        <img src="@/assets/icons/modal-header-close.svg" alt="modal-header-close" />
      </template>
      <template v-slot:modal-title>
        <div class="flex items-center w-full justify-between">
          <Input
            label="Добавьте название услуги:"
            placeholder="Введите название"
            classes="bg-hint w-110"
            :invalid="$v.service.name.$error"
            v-model="service.name"/>
          <button class="btn btn-sm btn-primary font-normal"
          @click="onEditServiceSend">Опубликовать услугу</button>
        </div>
      </template>
      <div slot class="flex flex-col pt-8">
        <div class="flex flex-col space-y-8 pl-48">
          <Input
            label="Категория услуг:"
            placeholder=""
            classes="w-150"
            :disabled="true"
            :icon="category.iconAttach"
            v-model="category.name"/>
          <V2AttachmentUpload
            mode="card"
            v-model="service.v2ImageAttach"
            title="Изображение услуги для новой формы"
            hint="Можно загрузить, заменить или убрать. Если картинки нет, используется fallback. Рекомендуемый размер — 1024×1024."
          />
          <Input
            label="Описание услуги:"
            :textarea="true"
            placeholder="Введите описание услуги"
            classes="w-150"
            :invalid="$v.service.description.$error"
            v-model="service.description"/>
          <Input
            label="Стоимость услуги:"
            placeholder="Введите стоимость"
            classes="bg-hint w-110"
            :inputmask="{
              alias: 'decimal',
              rightAlign: false,
              allowMinus: false,
              placeholder: '',
            }"
            :invalid="$v.service.price.$error"
            v-model="service.price"/>
          <div class="flex flex-col">
            <span class="flex text-sm text-muted mb-4">Тип товара:</span>
            <RadioButtonSet :options="countableOptions"
            :invalid="$v.service.countable.$error"
            v-model="service.countable" size="big" />
          </div>
          <div class="flex flex-col">
            <span class="flex text-sm text-muted mb-4">Обязательное поле для заказа:</span>
            <RadioButtonSet :options="requiredOptions"
            :invalid="$v.service.required.$error"
            v-model="service.required" size="big" />
          </div>
        </div>
        <div class="flex flex-col py-8 border-t border-solid border-light pl-48 mt-8">
          <Input
            label="Дополнительные опции:"
            placeholder="Укажите дополнительные опции"
            classes="bg-hint border-none w-110"
            v-model="optionName"
            @enter="onEnter"
            :options="additionalOptions"
            @option-delete="onOptionDelete"
            />
        </div>
        <div class="flex flex-col py-8 border-t border-solid border-light pl-48">
          <span class="flex text-sm text-muted mb-4">Показывать на экране Поиска:</span>
          <RadioButtonSet :options="showAtMobileSearchScreenOptions" size="big"
          :invalid="$v.service.showAtMobileSearchScreen.$error"
          v-model="service.showAtMobileSearchScreen" />
        </div>
        <div class="flex flex-col py-8 border-t border-solid border-light pl-48">
          <div class="max-w-300px pb-16">
            <span class="flex text-sm text-muted mb-4">Для каких объектов доступна услуга:</span>
            <Select
            :options="applicableToOptions"
            :class="['bg-hint', {
              'border border-solid border-hint':
                !$v.service.applicableTo.$dirty || !$v.service.applicableTo.$invalid,
              'border border-solid border-danger':
                $v.service.applicableTo.$dirty && $v.service.applicableTo.$invalid,
            }]"
            :label="'name'"
            :value="service.applicableTo"
            @input="($event) => service.applicableTo = $event"
            placeholder="Выберите доступность услуги"/>
          </div>
        </div>
      </div>
    </Modal>
    <Modal
      id="delete"
      :hide-footer="true"
      >
      <template v-slot:modal-title>
        <span class="modal-title">Удаление категории услуг</span>
      </template>
      <div slot class="flex flex-col items-center p-8">
        <p class="text-center text-16px leading-22px mb-6 text-muted">
          Вы точно хотите удалить категорию
          <span class="text-base text-primary"
          v-if="category && category.name">{{ category.name }}</span>?
        </p>
        <div class="flex items-center justify-center w-full">
          <span
            class="text-16px leading-18px text-danger font-bold cursor-pointer mr-10"
            @click="(e) => onDelete(e, this.category.id)">
            Удалить
          </span>
          <span
            class="text-16px leading-18px text-secondary font-bold cursor-pointer"
            @click="() => $bvModal.hide('delete')">
            Отменить удаление
          </span>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import RouterTabs from '@/components/RouterTabs.vue';
import CategoryCard from '@/components/Services/CategoryCard.vue';
import Modal from '@/components/Modal.vue';
import Input from '@/components/Input.vue';
import Select from '@/components/Select.vue';
import RadioButtonSet from '@/components/RadioButtonSet.vue';
import V2AttachmentUpload from '@/components/Services/V2AttachmentUpload.vue';

export default {
  components: {
    CategoryCard,
    RouterTabs,
    Modal,
    Input,
    Select,
    RadioButtonSet,
    V2AttachmentUpload,
  },
  data() {
    return {
      tabs: [
        { title: 'Услуги категории', push: { name: 'services.categories.category.services' } },
        { title: 'Информация по категории', push: { name: 'services.categories.category.about' } },
      ],
      serviceId: null,
      service: {
        name: null,
        description: null,
        price: null,
        countable: null,
        required: null,
        showAtMobileSearchScreen: null,
        applicableTo: null,
        archive: false,
        v2ImageAttach: null,
      },
      optionName: '',
      additionalOptions: [],
      additionalOptionsToUpdate: [],
      countableOptions: [
        { name: 'Количественный товар', value: true },
        { name: 'Не количественный', value: false },
      ],
      requiredOptions: [
        { name: 'Обязательное', value: true },
        { name: 'Не обязательное', value: false },
      ],
      showAtMobileSearchScreenOptions: [
        { name: 'Показывать', value: true },
        { name: 'Не показывать', value: false },
      ],
      applicableToOptions: [
        {
          id: 1,
          name: 'Для всех Объектов',
          value: 'public',
        },
        {
          id: 2,
          name: 'Избранное',
          value: 'not_owned',
        },
        {
          id: 3,
          name: 'Только Владелец Объекта',
          value: 'owned',
        },
      ],
    };
  },
  validations: {
    service: {
      name: {
        required,
      },
      description: {
        required,
      },
      price: {
        required,
      },
      countable: {
        required,
      },
      required: {
        required,
      },
      showAtMobileSearchScreen: {
        required,
      },
      applicableTo: {
        required,
      },
    },
  },
  computed: {
    ...mapState({
      categories: (state) => state.services.categories,
    }),
    category() {
      if (this.categories && this.categories.length) {
        return this.categories.find((el) => el.id === this.$route.params.id);
      }
      return {};
    },
    services() {
      if (this.categories && this.categories.length && !_.isEmpty(this.category)) {
        return this.category.services;
      }
      return [];
    },
  },
  watch: {
    'service.applicableTo': {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(
      'services',
      [
        'ACT_FETCH_SERVICE_CATEGORIES',
        'ACT_UPDATE_SERVICE_CATEGORY',
        'ACT_DELETE_SERVICE_CATEGORY',
        'ACT_CREATE_SERVICE',
        'ACT_UPDATE_SERVICE',
        'ACT_CREATE_SERVICE_OPTION',
        'ACT_UPDATE_SERVICE_OPTION',
        'ACT_DELETE_SERVICE_OPTION',
        'ACT_ACTIVATE_CATEGORY',
        'ACT_DEACTIVATE_CATEGORY',
      ],
    ),
    async getServiceCategories() {
      await this.ACT_FETCH_SERVICE_CATEGORIES();
    },
    async createService(id) {
      const {
        name,
        description,
        price,
        countable,
        required: requiredObj,
        showAtMobileSearchScreen,
        archive,
        applicableTo,
        v2ImageAttach,
      } = this.service;
      await this.ACT_CREATE_SERVICE({
        id,
        name,
        description,
        price,
        countable: countable && countable.value,
        required: requiredObj && requiredObj.value,
        showAtMobileSearchScreen: showAtMobileSearchScreen && showAtMobileSearchScreen.value,
        archive,
        applicableTo: applicableTo && applicableTo.value,
        v2ImageAttach,
      }).then((response) => {
        const { data: serviceId } = response;
        if (response && serviceId && this.additionalOptions && this.additionalOptions.length) {
          this.additionalOptions.forEach(({ name: optionName }) => {
            this.ACT_CREATE_SERVICE_OPTION({
              id,
              serviceId,
              name: optionName,
            });
          });
        }
      });
    },
    async onServiceCreateClick(id) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.createService(id).then(() => {
          this.getServiceCategories().then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide('add');
            });
          });
        });
      }
    },
    async onSaveCategoryClick(id) {
      await this.ACT_UPDATE_SERVICE_CATEGORY({
        id,
        ...this.category,
      }).catch((error) => {
        console.log(error);
      });
    },
    onEnter(e) {
      if (this.optionName && this.optionName.length) {
        this.additionalOptions = [
          ...this.additionalOptions,
          { name: e, id: +new Date() },
        ];
      }
      this.optionName = '';
    },
    async onOptionDelete(optionId) {
      const excludeOptionsIds = [...this.additionalOptionsToUpdate.map((el) => el.id)];
      const localOption = this.additionalOptions
        .filter((el) => !excludeOptionsIds.includes(el.id))
        .find((el) => el.id === optionId);
      if (!_.isEmpty(localOption) && localOption.id === optionId) {
        this.additionalOptions = this.additionalOptions.filter((el) => el.id !== optionId);
      } else {
        await this.ACT_DELETE_SERVICE_OPTION({
          id: this.category.id,
          serviceId: this.serviceId,
          optionId,
        }).then((response) => {
          if (response.status === 200) {
            this.getServiceCategories().then(() => {
              this.additionalOptions = this.additionalOptions.filter((el) => el.id !== optionId);
              this.additionalOptionsToUpdate = this.additionalOptionsToUpdate
                .filter((el) => el.id !== optionId);
              this.$iwalyNotify.success({
                text: 'Опция успешно удалена!',
              });
            });
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    },
    async onDelete(e, id) {
      await this.ACT_DELETE_SERVICE_CATEGORY({ id }).then(() => {
        this.$nextTick(() => {
          this.$bvModal.hide('delete');
          this.$router.push({
            name: 'services.categories',
          });
        });
      }).catch((error) => {
        console.log(error);
        this.$nextTick(() => {
          this.$bvModal.hide('delete');
        });
      });
    },
    async onDeleteCategoryClick() {
      this.$nextTick(() => {
        this.$bvModal.show('delete');
      });
    },
    resetValidation() {
      this.$v.$reset();
    },
    editService(id) {
      const currentService = this.category.services.find((el) => el.id === id);
      const {
        name,
        description,
        price,
        countable,
        required: requiredValue,
        showAtMobileSearchScreen,
        archive,
        applicableTo,
        options,
        v2ImageAttach,
      } = currentService;
      this.service = {
        ...this.service,
        name,
        description,
        price,
        countable: this.countableOptions.find((el) => el.value === countable),
        required: this.requiredOptions.find((el) => el.value === requiredValue),
        showAtMobileSearchScreen: this.showAtMobileSearchScreenOptions
          .find((el) => el.value === showAtMobileSearchScreen),
        archive,
        applicableTo: this.applicableToOptions.find((el) => el.value === applicableTo),
        v2ImageAttach,
      };
      this.additionalOptions = options;
    },
    onEditService(id) {
      this.resetValidation();
      const currentService = this.category.services.find((el) => el.id === id);
      const { options } = currentService;
      this.additionalOptionsToUpdate = options;
      this.$bvModal.show('edit');
      this.serviceId = id;
      this.editService(id, this.category.id);
    },
    async onEditServiceClick(id) {
      const {
        name,
        description,
        price,
        countable,
        required: requiredObj,
        showAtMobileSearchScreen,
        archive,
        applicableTo,
        v2ImageAttach,
      } = this.service;
      await this.ACT_UPDATE_SERVICE({
        id,
        serviceId: this.serviceId,
        name,
        description,
        price,
        countable: countable && countable.value,
        required: requiredObj && requiredObj.value,
        showAtMobileSearchScreen: showAtMobileSearchScreen && showAtMobileSearchScreen.value,
        archive,
        applicableTo: applicableTo && applicableTo.value,
        v2ImageAttach,
      }).then(() => {
        if (this.additionalOptionsToUpdate && this.additionalOptionsToUpdate.length) {
          this.additionalOptionsToUpdate.forEach((option) => {
            this.ACT_UPDATE_SERVICE_OPTION({
              id,
              serviceId: this.serviceId,
              optionId: option.id,
              name: option.name,
            }).catch((error) => {
              console.log(error);
            });
          });
        }
        const excludeOptionsIds = [...this.additionalOptionsToUpdate.map((el) => el.id)];
        const arrayToCreate = this.additionalOptions
          .filter((el) => !excludeOptionsIds.includes(el.id));
        arrayToCreate.forEach(({ name: optionName }) => {
          this.ACT_CREATE_SERVICE_OPTION({
            id,
            serviceId: this.serviceId,
            name: optionName,
          }).catch((error) => {
            console.log(error);
          });
        });
      }).catch((error) => {
        console.log(error);
      });
    },
    onEditServiceSend() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.onEditServiceClick(this.category.id).then(() => {
          this.getServiceCategories().then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide('edit');
            });
          });
        });
      }
    },
    onEditModalHidden() {
      this.service = {
        name: null,
        description: null,
        price: null,
        countable: null,
        required: null,
        showAtMobileSearchScreen: null,
        applicableTo: null,
        archive: false,
        v2ImageAttach: null,
      };
    },
    onCategoryActivate(id) {
      this.ACT_ACTIVATE_CATEGORY(id);
    },
    onCategoryDeactivate(id) {
      this.ACT_DEACTIVATE_CATEGORY(id);
    },
  },
  created() {
    this.getServiceCategories();
    this.$eventBus.$on('service-edit', this.onEditService);
  },
  beforeDestroy() {
    this.$eventBus.$off('service-edit', this.onEditService);
  },
};
</script>
